import React, { useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Detail as DetailComponent, InfoHeader, useDrawer } from 'src/mtska-frontend-app-component';
import { useDataProvider } from 'src/mtska-frontend-data-provider';
import { AppContext } from 'src/mtska-frontend-app-scaffolding';
import JSONPretty from 'react-json-pretty';

const dataProviderName = 'administrations/revenuedeal';
const wizardName = 'Revenue Deal duplicate';
const wizardAction = 'duplicate';

const Duplicate = (params) => {
    const { t } = useTranslation();
    const { close } = useDrawer();
    const { userCapabilities, existingModules } = useContext(AppContext);

    const { item, doAction, errorMessage, errors, saving, success } = useDataProvider(dataProviderName, true);

    const modelName = existingModules.modelName

    const getDetailConfigBySelectedLength = () => {
        console.info('getDetailConfigBySelectedLength', params, params.items)
        if (params.items?.length == 1) {
            return {
                "tabs": [
                    {
                        "name": "document",
                        "fieldsets": [
                            {
                                "name": "document",
                                "fields": {
                                    "info": {
                                        "type": "sectionmessageblock",
                                        "title": "duplicate_single_rd_title",
                                        "paragraph": "duplicate_single_rd_paragraph",
                                        "icon": "faSplit",
                                        "className": "col-12 info",
                                    },
                                    "addYear": {
                                        "type": "select",
                                        "className": "col-12",
                                        "options": [
                                            {
                                                "label": "true",
                                                "value": "true"
                                            },
                                            {
                                                "label": "false",
                                                "value": "false"
                                            }
                                        ]
                                    },
                                    "change_partner_id": {
                                        "type": "select",
                                        "className": "col-12",
                                        "options": [
                                            {
                                                "label": "true",
                                                "value": "true"
                                            },
                                            {
                                                "label": "false",
                                                "value": "false"
                                            }
                                        ]
                                    },
                                    "partner_id": {
                                        "type": "legalEntityList",
                                        "required": true,
                                        "className": "col-12",
                                        "disableMultipleRowSelection": true,
                                        "hideTableToolbar": true,
                                        "relation": {
                                            "columnsNeeded": [
                                                "name",
                                                "type",
                                                "supplier_type"
                                            ],
                                        },
                                        "filters": {
                                            "items": [
                                                {
                                                    "field": "type",
                                                    "operator": "isAnyOf",
                                                    "value": ["supplier"]
                                                }
                                            ]
                                        },
                                        "visibilitycondition": [
                                            [
                                                "change_partner_id",
                                                "=",
                                                "true"
                                            ]
                                        ]
                                    }
                                }
                            }
                        ]
                    }
                ],
                "validation": []
            }
        } else {
            return {
                "tabs": [
                    {
                        "name": "document",
                        "fieldsets": [
                            {
                                "name": "document",
                                "fields": {
                                    "info": {
                                        "type": "sectionmessageblock",
                                        "title": "duplicate_multi_rd_title",
                                        "paragraph": "duplicate_multi_rd_paragraph",
                                        "icon": "faSplit",
                                        "className": "col-12 warning",
                                    },
                                }
                            }
                        ]
                    }
                ],
                "validation": []
            }
        }
    }
    const detailConfig = getDetailConfigBySelectedLength()

    useEffect(() => {
        if (success) {
            close();
        }
    }, [success]);

    const handleSave = (data) => {
        doAction({ action: wizardAction, model: dataProviderName, data: data }).then((data) => params.handleClose(params.uid, data.item.data)).catch(() => console.error('catch handleSave'));
    }

    return <>
        {/* <JSONPretty data={params} className="json-wrapper" /> */}
        <DetailComponent
            disableDetailConfigOverride={true}
            values={{
                "addYear": "true",
                "change_partner_id": "false",
                "revenueDeals": params.items,
            }}
            modelName={modelName}
            detailConfig={detailConfig}
            dataProviderName={dataProviderName}
            save={handleSave}
            saving={saving}
            errors={errors}
            errorMessage={errorMessage}
            title={t(wizardName)}
            canSave={userCapabilities && userCapabilities[dataProviderName + '.' + wizardAction.toLowerCase()]}
            header={
                <InfoHeader
                    view="wizard"
                    title={t(wizardName)}
                    subtitle={t('Duplicate revenue deal')}
                />
            }
            {...params}
        />
    </>
}

export default Duplicate;


